
import { defineComponent, computed } from 'vue'

import DwLoader from '@/modules/DispatcherWorkplaceModule/ui/DwLoader/index.vue'

export default defineComponent({
    components: {
        'dw-loader': DwLoader
    },
    props: {
        size: {
            type: String,
            default: 'medium'
        },
        color: {
            type: String,
            default: 'primary'
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['click'],
    setup(props, { emit }) {
        const onClick = (event: Event) => {
            if (props.disabled || props.loading) return
            emit('click', event)
        }

        const dwButtonClasses = computed(() => {
            return {
                [`dw-button--${props.size}`]: true,
                [`dw-button--${props.color}`]: true,
            }
        })

        return {
            onClick,
            dwButtonClasses
        }
    }
})
